import validatorLib from 'validator';

export const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export const numericOnlyNormalization = value => {
  if (!value) {
    return '';
  }
  return value.replace(/[^\d]/g, '');
};

export const simpleSetValueFormMutator = {
  setValue: ([field, value], state, { changeValue }) =>
    changeValue(state, field, () => value),
};

export const requiredStringValidation = (
  message = 'This field is required'
) => value =>
  !value || validatorLib.isEmpty(value.trim()) ? message : undefined;

export const validUrlValidation = (
  message = 'Please enter a valid link'
) => value =>
  value &&
  !validatorLib.isURL(value.trim(), {
    protocols: ['http', 'https'],
    require_protocol: true,
  })
    ? message
    : undefined;

const isEmptyValue = value => {
  return value === undefined || value === null || value === '';
};

export const requiredFieldValidation = (value, fieldName = 'This field') => {
  if (isEmptyValue(value)) {
    return `${fieldName} is required`;
  }
  return null;
};

export const rangeValidation = (value, min, max, fieldName = 'Value') => {
  if (value < min || value > max) {
    return `${fieldName} must be between ${min} and ${max}`;
  }
  return null;
};

export const optionalDiscountPercentageValidation = (
  value,
  fieldName = 'Discount percentage'
) => {
  if (isEmptyValue(value)) {
    return null;
  }
  return rangeValidation(Number(value), 0, 100, fieldName);
};

export const minValueValidation = (value, min, fieldName = 'Value') => {
  if (value < min) {
    return `${fieldName} must be ${
      min === 0 ? 'a positive number' : `at least ${min}`
    }`;
  }
  return null;
};

export const maxSafeIntegerValidation = (value, fieldName = 'Value') => {
  if (Number(value) > Number.MAX_SAFE_INTEGER) {
    return `${fieldName} is too large. Maximum allowed value is ${Number.MAX_SAFE_INTEGER.toLocaleString(
      'id-ID'
    )}`;
  }
  return null;
};

export const maxLengthValidation = (value, max, fieldName = 'This field') => {
  if (value && value.length > max) {
    return `${fieldName} must not exceed ${max} characters`;
  }
  return null;
};

export const requiredArrayValidation = (value, fieldName) => {
  if (!value || value.length === 0) {
    return `Please select at least one ${fieldName}`;
  }
  return null;
};
